// Where a markdown link should go. Admin docs are served by the SPA
// (`/admin-documentation?page=x`); pages outside it (FAQ) link to the public
// MkDocs site, which serves `page.md` at `/docs/page/`.
export const resolveDocLink = (href, { docsRouteBase = '/documentation', externalDocsBase = null } = {}) => {
  const value = href || '';
  if (/^(https?:|mailto:)/i.test(value)) return { kind: 'plain', href: value };
  const match = value.match(/^([^#?]+)\.md(#.*)?$/);
  if (!match) return { kind: 'plain', href: value };
  const page = match[1].replace(/^\.\//, '');
  const anchor = match[2] || '';
  if (externalDocsBase) {
    // MkDocs directory-URL rule: dir/index.md builds to /dir/, not /dir/index/
    const cleanPage = page.replace(/(^|\/)index$/, '');
    const baseUrl = cleanPage ? `${externalDocsBase}${cleanPage}/` : externalDocsBase;
    return { kind: 'external', href: `${baseUrl}${anchor}` };
  }
  return { kind: 'internal', href: `${docsRouteBase}?page=${page}${anchor}` };
};
